// extracted by mini-css-extract-plugin
export default {"qrbox":"html5-qrcode_qrbox__AVpT9"};